<template>
  <v-container
    fluid
    v-if="accessViewTenants()"
  >
    <base-material-card
      inline
      icon="mdi-warehouse"
      title="Tenants"
    >
      <empty-space />
      <v-form>
        <v-row>
          <v-col cols="3">
            <tenant-type
              label="Tenant type"
              v-model="type"
            ></tenant-type>
          </v-col>
          <v-col cols="3">
            <site-infrastructure-owner
              label="Site infrastructure owner"
              v-model="infrastructureOwner"
            >
            </site-infrastructure-owner>
          </v-col>
          <v-col cols="3">
            <text-field
              label="Tenant Site ID & Site Name"
              v-model="tenantSiteId"
            >
            </text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              color="primary"
              @click="doFilter"
            >Filter</v-btn>
            <v-btn
              color=""
              @click="doCancel"
            >Cancel</v-btn>
          </v-col>
        </v-row>
      </v-form>
    </base-material-card>
    <v-card
      class="v-card--material pa-3"
    >
      <h2>Results</h2>
      <data-table
        ref="table"
        :fetch-from="fetchForm"
        :fields="fields"
      >
        <template
          slot="site"
          slot-scope="slotData"
        >
          <v-btn
            @click="openSite(slotData.rowData.site_id)"
            outlined
            flat
            small
          >{{ slotData.rowData.site.site_id_display }} {{ slotData.rowData.site.site_name }}</v-btn>
        </template>
        <template
          slot="actions"
          slot-scope="slotData"
        >
          <v-btn
            x-small
            color="primary"
            @click="openSite(slotData.rowData.site_id)"
          >Details</v-btn>
        </template>
      </data-table>
    </v-card>
  </v-container>
</template>

<script>
  import DataTable from '../../components/DataTable'
  import DatePicker from '../../components/DatePicker'
  import NewUsed from '../../components/codelist/NewUsed'
  import EmptySpace from '../../components/EmptySpace'
  import BatteryType from '../../components/codelist/BatteryType'
  import BatteryStatus from '../../components/codelist/BatteryStatus'
  import SiteInvestmentType from '@/components/codelist/SiteInvestmentType'
  import TenantSelect from '@/components/codelist/TenantSelect'
  import SiteInfrastructureOwner from '@/components/codelist/SiteInfrastructureOwner'
  import SiteTenantService from '@/services/site-tenant'
  import TextField from '@/components/TextField'
  import TenantType from '@/components/codelist/TenantType'
  import PermissionsMixin from '@/mixins/Permissions'
  export default {
    name: 'Battery',
    components: { TenantType, TextField, SiteInfrastructureOwner, TenantSelect, SiteInvestmentType, BatteryStatus, BatteryType, EmptySpace, NewUsed, DatePicker, DataTable },
    mixins: [
      PermissionsMixin,
    ],
    data: () => ({
      type: undefined,
      infrastructureOwner: undefined,
      tenantSiteId: undefined,
      fields: [
        {
          name: 'tenant_type_name',
          title: 'Tenant type',
        },
        {
          name: 'site_infrastructure_owner_name',
          title: 'Site infrastructure owner',
        },
        {
          name: 'site_id_site_name',
          title: 'Tenant Site ID & Site Name',
        },
        {
          name: '__slot:site',
          title: 'Site',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
        },
      ],
    }),
    methods: {
      fetchForm (urls, options) {
        const ss = new SiteTenantService()
        return ss.filter({
          tenant_type: this.type,
          infrastructure_owner: this.infrastructureOwner,
          tenant_site_id: this.tenantSiteId,
        }, options.params)
      },
      openSite (siteId) {
        this.$router.push('/sites/' + siteId + '/view')
      },
      doFilter () {
        this.$refs.table.refresh()
      },
      doCancel () {
        this.infrastructureOwner = undefined
        this.type = undefined
        this.tenantSiteId = undefined
        this.$refs.table.refresh()
      },

    },
  }
</script>

<style scoped>

</style>
